<div class="context-top-buttons">
  <button
    appButton
    name="share"
    location="asset-context-menu"
    [hasIcon]="true"
    spacing="full"
    [verticalIcon]="true"
    height="1"
    color="hard-simple"
    (click)="openShare.emit(); onClose.emit()"
  >
    <app-svg src="/assets/icons/forward.svg"></app-svg>
    <span>{{ 'asset-context-share' | translate }}</span>
  </button>
  @if (allowDownload()) {
    <app-asset-download-button
      location="asset-header"
      [asset]="asset()"
      [gallery]="gallery()"
      [galleryPermissions]="galleryPermissions()"
      [clientEl]="clientEl()"
    >
      <button
        appButton
        name="download"
        location="asset-context-menu"
        [hasIcon]="true"
        spacing="full"
        [verticalIcon]="true"
        height="1"
        color="hard-simple"
      >
        <app-svg src="/assets/icons/download.svg"></app-svg>
        <span>{{ 'asset-context-download' | translate }}</span>
      </button>
    </app-asset-download-button>
  }
</div>
<div class="divider"></div>
<div class="button-menu">
  @if (galleryPermissions().can_edit) {
    <label
      appButton
      name="upload-replacement"
      location="asset-context-menu"
      [hasIcon]="true"
      spacing="full"
      color="simple"
      shape="small"
      height="1"
      for="replace-upload"
    >
      <app-svg src="/assets/icons/upload.svg"></app-svg>
      <span>{{ 'asset-context-replace' | translate }}</span>
      <input
        type="file"
        id="replace-upload"
        #versionUpload
        class="hidden-input"
        (change)="uploadAssetEvent($event.target)"
        accept="*"
      />
    </label>
    @if (canDisplayAsset()) {
      <app-button-menu-item
        name="create-cdn-link"
        location="asset-context-menu"
        icon="link"
        (click)="createCdnLink(); onClose.emit()"
        [fullWidth]="true"
      >
        <span>Create CDN Link</span>
        <app-upgrade-badge location="asset-context-menu" scope="asset:create-cdn-link"></app-upgrade-badge>
      </app-button-menu-item>
      <app-button-menu-item
        name="set-as-cover"
        location="asset-context-menu"
        icon="height-medium"
        (click)="setAsCover()"
        [fullWidth]="true"
      >
        {{ 'asset-context-set-as-cover' | translate }}
      </app-button-menu-item>
      @if (asset() | canWatermarkAsset) {
        @if (gallery().watermark) {
          <app-button-menu-item
            name="toggle-watermark"
            location="asset-context-menu"
            icon="watermark"
            (click)="toggleWatermark(); onClose.emit()"
            [fullWidth]="true"
          >
            @if (asset().watermark_enabled) {
              <span>Hide Watermark</span>
            } @else {
              <span>Add Watermark</span>
            }
          </app-button-menu-item>
        } @else {
          <app-button-menu-item
            name="add-watermark"
            location="asset-context-menu"
            icon="watermark"
            (click)="openWatermarkingSettings(); onClose.emit()"
            [fullWidth]="true"
          >
            Add Watermark
            <app-upgrade-badge location="asset-context-menu" scope="asset:watermarking"></app-upgrade-badge>
          </app-button-menu-item>
        }
      }

      @if (asset().type === 'video') {
        <label
          appButton
          name="add-custom-video-poster"
          location="asset-context-menu"
          [hasIcon]="true"
          spacing="full"
          color="simple"
          shape="small"
          height="1"
          for="custom-poster-upload"
        >
          <app-svg src="/assets/icons/video-poster.svg"></app-svg>
          <span>Change Preview</span>
          <app-upgrade-badge location="asset-context-menu" scope="asset:custom-video-poster"></app-upgrade-badge>
          <input
            type="file"
            id="custom-poster-upload"
            [disabled]="!('asset:custom-video-poster' | billingScope)"
            #posterUpload
            class="hidden-input"
            (change)="uploadCustomPoster($event.target)"
            accept="image/*"
          />
        </label>

        @if (autoplayShown()) {
          <app-button-menu-item
            name="toggle-autoplay"
            location="asset-context-menu"
            icon="video-loop"
            (onClick)="toggleAutoplay(); onClose.emit()"
            [fullWidth]="true"
            [fullWidthButtonContent]="true"
          >
            <span>Autoplay</span>
            <app-upgrade-badge location="asset-context-menu" scope="asset:autoplay"></app-upgrade-badge>
            @if ('asset:autoplay' | billingScope) {
              <app-switch [noInteraction]="true" [small]="true">
                <input type="checkbox" id="{{ asset().id }}_autoplay" [checked]="asset().autoplay" />
                <label for="{{ asset().id }}_autoplay"></label>
              </app-switch>
            }
          </app-button-menu-item>
        }
      }
    }

    <div class="divider"></div>
  }
  @if (galleryPermissions().can_edit) {
    <app-button-menu-item
      name="move-asset"
      location="asset-context-menu"
      icon="move-out"
      (click)="moveAsset(); onClose.emit()"
      [fullWidth]="true"
    >
      Move/Copy to (
      <div class="grey-50">...</div>
      )
    </app-button-menu-item>
    <app-button-menu-item
      name="delete"
      location="asset-context-menu"
      icon="trash"
      color="simple-warn"
      data-test-id="delete-asset"
      (click)="deleteAsset(); onClose.emit()"
      [fullWidth]="true"
    >
      {{ 'asset-context-delete' | translate }}
    </app-button-menu-item>
  }
</div>
